import { BJ_PROTOCAL_URL, MODE_CREATE } from "constant/config";

type MessageType = {
	id?: number;
	url?: string;
	question?: string;
	action?: string;
	width?: number;
	height?: number;
};
const postMessage = (mode: string, data: MessageType) => {
	try {
		if (mode === "view") {
			window.top.postMessage(data, BJ_PROTOCAL_URL);
		} else {
			window.opener.postMessage(data, BJ_PROTOCAL_URL);
		}
	} catch (err) {}
};

/**
 * 방송국 소스로 postMessage 전달
 * @param param0
 */
export const votePostMessage = ({ action, id, url, question }: MessageType) => {
	postMessage(MODE_CREATE, { action, id, url, question });
};

/**
 * 방송국 소스로 postMessage 전달
 * @param param0
 */
export const voteViewResizeMessage = (mode: string, id: string) => (width: number, height: number) => {
	postMessage(mode, { action: "resize", id:Number(id), height: height + 1 });
};
